import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { jobs_fetcher } from "@/helpers/jobs_fetcher";
import { JobCard, Title } from "@/ui";
import clsx from "classnames";
import { chunk } from "lodash";
import { useState } from "react";
import { Carousel, Col, Container, Row, Stack } from "react-bootstrap";
import classes from "./styles.module.scss";

export const LatestJobs = ({
  className,
  title,
  button,
  visibleCount,
  jobLimit,
  sector,
  practice_area,
  titleColor,
  bgColor,
}) => {
  const [items] = useState(
    jobs_fetcher.fetch({
      limit: jobLimit,
      sector,
      practice_area,
    }),
  );

  return (
    <div className={clsx(className, classes.jobs, `bg-${bgColor}`)}>
      <Container className="mw-xxl">
        <Stack className="flex-md-row justify-content-between mb-4">
          <Title title={title} className={clsx("mb-md-0 text-center text-md-start", `text-${titleColor}`)} />
        </Stack>
        <Carousel
          controls={items.length > visibleCount}
          indicators={false}
          prevIcon={<ChevronLeft width="14" height="25" />}
          nextIcon={<ChevronRight width="14" height="25" />}
        >
          {chunk(items, visibleCount).map((items, k) => (
            <Carousel.Item key={k}>
              <Row>
                {items.map((job, k) => (
                  <Col key={k} xs={12} lg={12 / visibleCount} className={clsx("mb-4")}>
                    <JobCard className="bg-white h-100 " {...job} />
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <div className={classes.jobs__footer}>
          {button && (
            <a className={classes.jobs__link} href={button.href}>
              {button.label}
              <ChevronRight width="7" height="13" className="ms-2" />
            </a>
          )}
        </div>
      </Container>
    </div>
  );
};

export default LatestJobs;
